/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateDestinationRequestDestinationMetadata } from './UpdateDestinationRequestDestinationMetadata';
import {
    UpdateDestinationRequestDestinationMetadataFromJSON,
    UpdateDestinationRequestDestinationMetadataFromJSONTyped,
    UpdateDestinationRequestDestinationMetadataToJSON,
} from './UpdateDestinationRequestDestinationMetadata';
import type { UpdateDestinationRequestDestinationSecrets } from './UpdateDestinationRequestDestinationSecrets';
import {
    UpdateDestinationRequestDestinationSecretsFromJSON,
    UpdateDestinationRequestDestinationSecretsFromJSONTyped,
    UpdateDestinationRequestDestinationSecretsToJSON,
} from './UpdateDestinationRequestDestinationSecrets';

/**
 * 
 * @export
 * @interface UpdateDestinationRequestDestination
 */
export interface UpdateDestinationRequestDestination {
    /**
     * User-friendly name for the destination
     * @type {string}
     * @memberof UpdateDestinationRequestDestination
     */
    name?: string;
    /**
     * 
     * @type {UpdateDestinationRequestDestinationMetadata}
     * @memberof UpdateDestinationRequestDestination
     */
    metadata?: UpdateDestinationRequestDestinationMetadata;
    /**
     * 
     * @type {UpdateDestinationRequestDestinationSecrets}
     * @memberof UpdateDestinationRequestDestination
     */
    secrets?: UpdateDestinationRequestDestinationSecrets;
}

/**
 * Check if a given object implements the UpdateDestinationRequestDestination interface.
 */
export function instanceOfUpdateDestinationRequestDestination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateDestinationRequestDestinationFromJSON(json: any): UpdateDestinationRequestDestination {
    return UpdateDestinationRequestDestinationFromJSONTyped(json, false);
}

export function UpdateDestinationRequestDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDestinationRequestDestination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'metadata': !exists(json, 'metadata') ? undefined : UpdateDestinationRequestDestinationMetadataFromJSON(json['metadata']),
        'secrets': !exists(json, 'secrets') ? undefined : UpdateDestinationRequestDestinationSecretsFromJSON(json['secrets']),
    };
}

export function UpdateDestinationRequestDestinationToJSON(value?: UpdateDestinationRequestDestination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'metadata': UpdateDestinationRequestDestinationMetadataToJSON(value.metadata),
        'secrets': UpdateDestinationRequestDestinationSecretsToJSON(value.secrets),
    };
}

